import { render, staticRenderFns } from "./UserOnly.vue?vue&type=template&id=060e9a76&scoped=true"
import script from "./UserOnly.vue?vue&type=script&lang=js"
export * from "./UserOnly.vue?vue&type=script&lang=js"
import style0 from "./UserOnly.vue?vue&type=style&index=0&id=060e9a76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e9a76",
  null
  
)

export default component.exports